import { Avatar, Button, Grid, Typography, useTheme } from "@material-ui/core";

import React from "react";
import { FILE_TYPE, documentStatus } from "../config";

export default function DocumentationRequired({ document, handleOpen }) {
  const { palette } = useTheme();

  if (document === undefined) {
    return null;
  }

  const getColorByDocumentStatus = (status) => {
    switch (status) {
      case documentStatus.PENDING:
        return "secondary";
      case documentStatus.INCIDENCE:
        return "warning";
      default:
        return "success";
    }
  };

  const colorByStatus = getColorByDocumentStatus(document.status);

  return (
    <>
      <Button
        fullWidth
        elevation={0}
        onClick={(e) => handleOpen(e, document)}
        endIcon={<i className="material-icons">chevron_right</i>}
        style={{
          paddingTop: 20,
          paddingBottom: 20,
          borderRadius: 0,
          borderBottom: "solid 1px rgb(224,224,224)",
        }}
      >
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs={9}>
            <Typography variant="body2" color="textPrimary" align="left">
              {FILE_TYPE[document.name]
                ? FILE_TYPE[document.name]
                : document.description}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              style={{
                color: palette[colorByStatus].contrastText,
                backgroundColor: palette[colorByStatus].main,
                height: 20,
                width: 20,
                marginRight: 6,
              }}
            >
              <i className="material-icons" style={{ fontSize: 16 }}>
                {document.status === documentStatus.PENDING
                  ? "add"
                  : document.status === documentStatus.INCIDENCE
                  ? "priority_high"
                  : "check"}
              </i>
            </Avatar>
          </Grid>
        </Grid>
      </Button>
    </>
  );
}
